import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  'webApiSettings',
  function (runtimeConstant, webApiSettings) {
    function run() {
      try {
        var favicon = document.querySelector('#app-favicon');

        if (favicon)
        {
          var iconPath = '/public/favicon.ico';

          switch (webApiSettings.detailsCompany) {
            case 'abase':
              iconPath = '/images/AbsDOC.png';
              break;
            case 'hdoc':
              iconPath = '/images/hdoc_icon.png';
              break;
            case 'digitaldoc':
              iconPath = '/assets/images/favicon.png';
              break;
            case 'rb':
              iconPath = '/images/rb.png';
              break;
          }

          favicon.href = iconPath;
        } else {
          // eslint-disable-next-line no-console
          console.warn('Element #app-favicon not found.');
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugRunners)();
  },
];
